import { AppState } from '../reducers/app.state';

export const selectDiaryNotesStateDiaryNotes = (state: AppState) => state.diaryNotesData.diaryNotes;
export const selectDiaryNotesStateDiaryNotesError = (state: AppState) => state.diaryNotesData.diaryNotesErrors;
export const selectIsLoading = (state: AppState) => state.diaryNotesData.loading;
export const selectPagination = (state: AppState) => state.diaryNotesData.pagination;
export const selectTotalItems = (state: AppState) => state.diaryNotesData.totalItems;
export const selectSortData = (state: AppState) => state.diaryNotesData.sortData;
export const selectAvailableFilters = (state: AppState) => state.diaryNotesData.availableFilters;
export const selectActiveFilters = (state: AppState) => state.diaryNotesData.activeFilters;
export const selectIsLoaded = (state: AppState) => state.diaryNotesData.isLoaded;
